import { IReactProps } from 'types';

// @TODO replace "any" with generic component type
function combineComponents(components: any[]) {
  return components.reduce(
    (AccumulatedComponents, CurrentComponent) => {
      return ({ children }: IReactProps) => {
        return (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        );
      };
    },
    ({ children }: IReactProps) => <>{children}</>
  );
}

export default combineComponents;
